/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

//* ================== FOOTER MOBILE ACCORDION JS ================== *//

$(document).ready(function() {
  // checkViewportWidth();

  $(window).on("resize", function() {
    checkViewportWidth();
  });

  function checkViewportWidth() {
    var viewportWidth = $(window).width();

    if (viewportWidth <= 749) {
      // If viewport width is less than or equal to 749 pixels...

      $(".site-footer").addClass("gallery-mobile");
      $(".accordion-body").css("display", "none");
      $(".accordion-head").removeClass('active');

      // Unbind previous click event to avoid multiple bindings
      $('.accordion-head').off('click');

      // Attach a new click event to elements with class 'accordion-head'
      $('.accordion-head').on('click', function() {
       
          if ($('.accordion-body').is(':visible')) {
          // If they are, slide them up and reset some styles
          $(".accordion-body").slideUp(300);
          $(".plusminus").attr("src", "https://cdn.shopify.com/s/files/1/0850/7939/2541/files/accordion-plus.svg?v=1708402641");
          $(".accordion-head").removeClass('active');
        }

        // Check if the clicked element's next sibling with class 'accordion-body' is visible
        
        if ($(this).next(".accordion-body").is(':visible')) {
          $(this).next(".accordion-body").slideUp(300);
          $(this).children(".plusminus").attr("src", "https://cdn.shopify.com/s/files/1/0850/7939/2541/files/accordion-plus.svg?v=1708402641");
          
        } else {
          $(".accordion-head").addClass('active');
          $(this).next(".accordion-body").slideDown(300);
          $(this).children(".plusminus").attr("src", "https://cdn.shopify.com/s/files/1/0850/7939/2541/files/accordion-minus.svg?v=1708402641");
        }
      });
        
    } else {
      // If viewport width is greater than 749 pixels...

      $(".site-footer").removeClass("gallery-mobile");
      $(".accordion-body").css("display", "block"); 
      
      // Unbind click event for larger screens
      $('.accordion-head').off('click');
    }
  }


//* ================== FOOTER MOBILE ACCORDION JS ================== *//

    var accBody = $(".submenu-accordion-body");
    var accHead = $(".submenu-accordion-head");
    var downArrow = $(accHead).children(".accordion-arrow");
  
    $(accBody).css("display", "none");
    $(accHead).removeClass('active');
    $(downArrow).removeClass('up-arrow');

    // Unbind previous click event to avoid multiple bindings
    $(accHead).off('click');

    // Attach a new click event to elements with class 'submenu-accordion-head'
    $(accHead).on('click', function() {
     
        if ($(accBody).is(':visible')) {
        // If they are, slide them up and reset some styles
        $(accBody).slideUp(300);
        $(accHead).removeClass('active');
        $(downArrow).removeClass('up-arrow');
      }

      // Check if the clicked element's next sibling with class 'submenu-accordion-body' is visible
      
      if ($(this).next(accBody).is(':visible')) {
        $(this).next(accBody).slideUp(300);
        
      } else {
        $(accHead).addClass('active');
        $(this).next(accBody).slideDown(300);
        $(downArrow).addClass('up-arrow');
      }
    });
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
// })();


// product media slider
$( document ).ready(function() {
 
var $slick_slider = $('.product__slides.product-single__photos');
  var screen_size = 767;
  var settings_slider = {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
  }
  
  slick_on_mobile( $slick_slider, settings_slider);

  function slick_on_mobile(slider, settings){
      $(window).on('load resize', function() {
        if ($(window).width() > screen_size) {
          if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
          }
          return
        }
        if (!slider.hasClass('slick-initialized')) {
          return slider.slick(settings);
        }
      });
  };
  

    $('grid-slider .grid--slider').slick({
      dots: true,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToShow: 4.5,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  

    function productslider() {
    $('.product-recommendations').slick({
      dots: true,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToShow: 4.5,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    console.log('in');
  }
    var interval = setInterval(recommendedSlider, 500);
    function recommendedSlider() {
        if ($('#product-recommendations').children().length > 4) {
            clearInterval(interval);
            productslider();
        }
    }
  var intervalslick = setInterval(slickDotsHide, 500);
    function slickDotsHide() {
        if ($('.product__slides.product-single__photos').find('.slick-dots li').length > 0) {
            clearInterval(intervalslick);
          var sliderLength = $('.product__slides.product-single__photos').find('.slick-dots li').length;
            if(sliderLength == 1){
              $('.product__slides.product-single__photos').find('.slick-dots').addClass('hide-dots');
            }
        }
    }
  
  $('.upsell__product_wrap').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false
  });
  
});



//* ================== PRODUCT PAGE ADD TO CART BUTTON JS ================== *//

$(document).ready(function() {

$('.shop-the-look').slick({
  slidesToShow: 3, // Let CSS control width
  infinite: false,   // IMPORTANT: allows custom width (170px)
  slidesToScroll: 1,
  arrows: false,
  dots: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
});
  var addToCartBtn = $('.product__block--buttons');

  if ($('.dropdown__select').length === 0) {
      $(addToCartBtn).show();
      $(addToCartBtn).addClass('no-variant');
      $('.product__block.product__block--lines').removeClass('hide-btn');
    } 
  else {
      // $(addToCartBtn).hide();
      $('.product__block.product__block--lines').addClass('hide-btn');
    }  
  
  $('.dropdown__select').change(function() {
       var selectedOption = $(this).val();
      console.log('selectedOption',selectedOption);
    
      // Show or hide the "Add to Cart" button based on the selected option
      if (selectedOption !== '') {
        $(addToCartBtn).show();
        $('.product__block.product__block--lines').removeClass('hide-btn');
      } else {
        $(addToCartBtn).show();
        $('.product__block.product__block--lines').addClass('hide-btn');
      }   
   });
  document.querySelectorAll('.quick-add__button').forEach((btn) =>{
    btn.addEventListener("click", function() {
        setTimeout(function(){ 
          if(document.querySelectorAll('.product-quick-add').length > 0){
            console.log('in......');
            document.querySelectorAll('.product-quick-add').forEach((v_drop) =>{
              v_drop.querySelectorAll('.hidden-product-single__variants option').forEach(function(e) {
                  var selectedValue = e.value.trim();
                  e.closest('.product__form__outer').querySelectorAll('.product__selectors .dropdown__select option').forEach(function(el) {
                    var select_drop = el.value.trim();
                    if (select_drop == selectedValue) {
                      el.classList.add('available-variant-show');
                      el.remove();
                    } else {
                      // $(this).addClass('available-variant-hide');
                    }
                  });
                });
            })
          } 
       }, 1000);
       
    });
  })
});